export interface LanguageSetting {
    short: string;
    locale: string;
    lcid: string;
}

export const Languages: Array<LanguageSetting> = [
    {short: 'de', locale: 'de_DE', lcid: '407'}, /* also available: de_AT, de_LU, de_CH */
    {short: 'en', locale: 'en_US', lcid: '409'}, /* also available: many! */
    {short: 'es', locale: 'es_ES', lcid: 'C0A'}, /* also available: many! */
    {short: 'fr', locale: 'fr_FR', lcid: '40C'}, /* also available: fr_BE, fr_CA, fr_FR, fr_LU, fr_CH */
    {short: 'it', locale: 'it_IT', lcid: '410'}, /* also available: it_CH */
    {short: 'nl', locale: 'nl_NL', lcid: '413'}, /* also available: nl_BE */
    {short: 'pl', locale: 'pl_PL', lcid: '407'},
    {short: 'pt', locale: 'pt_PT', lcid: '816'}, /* also available: nl_BR (Brazil) */
    {short: 'ro', locale: 'ro_RO', lcid: '418'},
    {short: 'tr', locale: 'tr_TR', lcid: '41F'},
];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/Languages.ts